import { types } from './actions';

const initialState = {
  isFetchingTasks: false,
  tasks: [],
};

const reducer = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case types.DASHBOARD_LIST_INIT_ERROR:
      return {
        ...state,
        isFetchingTasks: false,
      };
    case types.DASHBOARD_LIST_INIT_REQUEST:
      return {
        ...state,
        isFetchingTasks: true,
        tasks: [],
      };
    case types.DASHBOARD_LIST_INIT_SUCCESS:
      return {
        ...state,
        isFetchingTasks: false,
        tasks: payload.tasks,
      };
    default:
      return state;
  }
};

const getScope = (state) => state.modules.tasks.dashboard;

export const getIsFetchingTasks = (state) => getScope(state).isFetchingTasks;

export const getTasks = (state) => getScope(state).tasks;

export default reducer;
